/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import { CreateForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import useProcessIncidentService from 'domain/gpo/cockpit/instance/Show/incident/processIncidentService';
import ResolveIncidentForm from 'domain/gpo/cockpit/instance/Show/incident/shared/ResolveIncidentForm';

const MESSAGE_CONTEXT = 'ResolveIncidentModalForm';

interface ResolveIncidentModalFormProps {
  closeModal: () => void;
  incidentId: string;
  updateIncidentList: () => void;
}

const ResolveIncidentModalForm = ({ closeModal, incidentId, updateIncidentList }: ResolveIncidentModalFormProps) => {
  const processInstanceId = useProcessInstanceId();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const { resolveIncident } = useProcessIncidentService();

  const closeForm = useCallback(() => {
    setIsModalOpen(false);
    closeModal();
  }, [setIsModalOpen, closeModal]);

  return (
    <CreateForm
      submitFormFunc={resolveIncident}
      messageContext={MESSAGE_CONTEXT}
      initialData={{
        processInstanceId,
        incidentId,
      }}
      afterSubmit={{
        execute: useCallback(() => {
          updateIncidentList();
          closeForm();
        }, [updateIncidentList, closeForm]),
        message: 'You are awesome! The Process Incident has been successfully resolved.',
      }}
    >
      <Modal
        key="modal-not-strict"
        modalSize="sm"
        backdrop="static"
        keyboard={false}
        isOpen={isModalOpen}
        hasCancelButton={false}
        title="Resolve process incident"
        onToggle={closeForm}
      >
        <ResolveIncidentForm handleCancelClick={closeForm} />
      </Modal>
    </CreateForm>
  );
};

export default ResolveIncidentModalForm;
